import { Typography } from '@mui/material'
import React from 'react'
import { ModalWrapper } from '../../../../../../components'
// import { closeIcon } from '../../../../../../assets/icons'
import { CloseCommonSuccess, CommonSuccess } from '../../School/SchoolRegistration/components/Steps'
import { useSelector } from 'react-redux'
import './van.css'
// import { useGlobal } from '../../../../../../shared'
// import { urls } from '../../../../../../shared/config'
// import { baseURL, urls } from '../../../../../../shared/config'
// import axios from 'axios'
// import {
//   setLoader,
//   setPassengerSchoolID,
//   setRefreshPage,
//   setVanID,
// } from '../../../../../../redux/globalSlice'

export const VanListDetails = ({ open, handleClose }) => {
  // const dispatch = useDispatch()
  const data = useSelector((state) => state.global.SchoolDInfo)
  // const VanId = data?.van_id
  // console.log(data)
  // const { data: passengerData } = useGlobal({ userUrl: `${urls.PASSENGER_GET}${VanId}` })
  // const passengersList = passengerData?.getPassengerPayload
  // const [deletingPassenger, setDeletingPassenger] = useState(null)
  // const handlePassOpen = () => {
  //   dispatch(setVanID(VanId))
  //   dispatch(setPassengerSchoolID(data?.school_id))
  //   // handleClose()
  //   handlePassengerOpen()
  // }
  // const handleDelete = async (studentId) => {
  //   dispatch(setLoader(true))
  //   try {
  //     const response = await axios.delete(`${baseURL}${urls.PASSENGER_DELETE}${studentId}`)
  //     if (response.status === 200 || response.status === 204) {
  //       console.log('Passenger deleted successfully')
  //       setDeletingPassenger(studentId)
  //       dispatch(setRefreshPage(true))
  //     } else {
  //       console.error('Failed to delete passenger', response)
  //       setDeletingPassenger(null)
  //       dispatch(setLoader(false))
  //     }
  //   } catch (error) {
  //     console.error('Error deleting passenger:', error)
  //     setDeletingPassenger(null)
  //     dispatch(setLoader(false))
  //   } finally {
  //     setDeletingPassenger(null)
  //   }
  // }
  return (
    <ModalWrapper open={open} handleClose={handleClose} width={'500px'} title={'Van Details'}>
      <div className="van-info">
        <Typography fontSize={'18px'} fontWeight={500}>
          Van Information
        </Typography>
        <div className="van-i-info">
          <VanInfo title={'Van Number'} value={data?.van_number} width={'150px'} />
          <VanInfo title={'Driver'} divider value={`${data?.employee_name}`} />
        </div>
        <div className="van-i-info">
          <VanInfo title={'Route'} value={data?.route_name} width={'150px'} />
          <VanInfo
            title={'Occupancy'}
            value={`${data?.student_count || 0}/${data?.van_size}`}
            divider
          />
        </div>
      </div>
      {/* <div className="van-info">
        <div className="space-between">
          <Typography fontWeight={500}>Passenger</Typography>
          <Typography
            sx={{ color: '#2970FE', cursor: 'pointer' }}
            fontSize={'16px'}
            fontWeight={700}
            onClick={handlePassOpen}
          >
            + Add Passenger
          </Typography>
        </div>
        <div className="passenger-list">
          {passengersList?.map((pass, index) => (
            <div
              className={`space-between passenger-txt ${
                deletingPassenger === pass.student_id ? 'slide-out' : ''
              }`}
              key={index}
            >
              <Typography fontSize={'14px'}>{pass.student_name}</Typography>
              <img
                src={closeIcon}
                alt="Delete"
                onClick={() => handleDelete(pass.student_id)}
                style={{ cursor: 'pointer' }}
              />
            </div>
          ))}
        </div>
      </div> */}
    </ModalWrapper>
  )
}

const VanInfo = ({ title, value, divider, width }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div style={{ width: width }}>
        <Typography className="grey-text" mb={1}>
          {title}
        </Typography>
        <Typography>{value}</Typography>
      </div>
      {!divider && <div className="van-info-box"></div>}
    </div>
  )
}

export const SetupComplete = ({ open, handleBoxClose }) => {
  return (
    <ModalWrapper open={open} adminAdd title={'Add New Expense'} width={'440px'}>
      <div className="success-expense">
        <CommonSuccess />
        <CloseCommonSuccess handleClose={handleBoxClose} />
      </div>
    </ModalWrapper>
  )
}
